import _ from "lodash";
import FuzzySearch from "fuzzy-search";

window.organizationOverview = () => {
  return {
    store: "company",
    fetchDataUri: null,
    specials: [],
    randomSpecials: [],
    searchedItems: [],
    filteredItems: [],
    filters: [],
    filterColor: false,
    filterInterviews: false,
    filterApprenticeships: false,
    filterTrialApprenticeships: false,
    filterEvents: false,
    searchTerm: "",
    searchOpen: false,
    searchLoading: false,
    searchResultsItems: [],
    loading: false,
    searchFallbacksItems: [],
    searchNoResults: false,

    init() {
      this.$store[this.store].fetch(this.fetchDataUri);
      this.searchedItems = this.$store[this.store].items;
      this._filterItems();
      this._generateRandomSpecials();

      this.$watch("searchTerm", () => this._search());
      this.$watch("searchedItems", () => this._filterItems());
      this.$watch("filters", () => this._filterItems());
      this.$watch("filterColor", () => this._filterItems());
      this.$watch("filterInterviews", () => this._filterItems());
      this.$watch("filterApprenticeships", () => this._filterItems());
      this.$watch("filterTrialApprenticeships", () => this._filterItems());
      this.$watch("filterEvents", () => this._filterItems());

      Spruce.watch(`${this.store}.items`, () => {
        this.searchedItems = this.$store[this.store].items;
      });
    },

    _generateRandomSpecials() {
      if (!this.specials || this.specials.length <= 0) return [];
      this.randomSpecials = this.specials
        .map((a) => [Math.random(), a])
        .sort((a, b) => a[0] - b[0])
        .map((a) => a[1])
        .slice(0, 3);
    },

    _search() {
      this.searchNoResults = false;
      this.searchResultsItems = [];
      this.searchFallbacksItems = [];

      if (this.searchTerm === "") {
        this.searchedItems = this.$store[this.store].items;
        this.searchResultsItems = [];
      } else {
        const searcher = new FuzzySearch(this.$store[this.store].items, [
          "title",
        ]);
        const result = searcher.search(this.searchTerm);

        if (result.length <= 0) {
          this.searchNoResults = true;
          this.searchedItems = this.$store[this.store].items;
          this.searchFallbacksItems = this.$store[this.store].items.filter(
            (item) =>
              item.title
                .toLowerCase()
                .startsWith(this.searchTerm.substr(0, 1).toLowerCase())
          );
        } else {
          this.searchedItems = result;
          this.searchResultsItems = result;
        }
      }
    },

    clearSearch() {
      this.searchTerm = "";
      this.searchResultsItems = [];
      this.searchFallbacksItems = [];
      this.searchNoResults = false;
    },

    closeSearch() {
      this.searchOpen = false;
    },

    get searchResults() {
      return this.searchResultsItems.slice(0, 6);
    },

    get searchResultsTotal() {
      return this.searchResultsItems.length;
    },

    get searchShowMore() {
      return this.searchResultsItems.length > 6;
    },

    get searchFallbacks() {
      return this.searchFallbacksItems;
    },

    _filterItems() {
      let filtered = this.searchedItems;

      if (this.filters.length > 0) {
        filtered = filtered.filter((item) =>
          item.filter.some((f) => this.filters.includes(f))
        );
      }
      if (this.filterColor && this.$store.pt.completed) {
        filtered = filtered.filter((item) =>
          item.filter.some((f) => this.$store.pt.has(f))
        );
      }
      if (this.filterInterviews) {
        filtered = filtered.filter((item) => item.filter.includes("schedules"));
      }
      if (this.filterApprenticeships) {
        filtered = filtered.filter((item) =>
          item.filter.includes("apprenticeships")
        );
      }
      if (this.filterTrialApprenticeships) {
        filtered = filtered.filter((item) =>
          item.filter.includes("trialApprenticeships")
        );
      }
      if (this.filterEvents) {
        filtered = filtered.filter((item) => item.filter.includes("events"));
      }

      this.filteredItems = filtered;
    },

    resetFilter() {
      this.filters = [];
    },

    get groupedItems() {
      const data = this.filteredItems.reduce((r, e) => {
        const group = e.title[0].toUpperCase();
        if (!r[group]) r[group] = { title: group, children: [e] };
        else r[group].children.push(e);
        return r;
      }, {});

      return _.sortBy(data, ["title"]);
    },

    get totalItems() {
      return this.filteredItems.length;
    },
  };
};
